/**
 * SHOPRYTHM BULK OILS — bulk-oils.js
 * Handles: segment tabs, product tabs, smooth scroll CTAs
 * Add to: assets/bulk-oils.js
 * No dependencies — pure vanilla JS.
 */

(function () {
  'use strict';

  /* ── SMOOTH SCROLL for all .boh__scroll-cta links ── */
  document.querySelectorAll('.boh__scroll-cta').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ── GENERIC TAB SWITCHER ── */
  function initTabs(tabSelector, panelIdPrefix) {
    var tabs = document.querySelectorAll(tabSelector);
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        /* deactivate all */
        tabs.forEach(function (t) {
          t.classList.remove(tabSelector.replace('.', '').replace('[', '').replace(']', '') + '--active');
          t.setAttribute('aria-selected', 'false');
        });
        /* hide all panels controlled by these tabs */
        var panelClass = panelIdPrefix + '--active';
        document.querySelectorAll('[id^="' + panelIdPrefix.replace('.boh__', '') + '-"]').forEach(function (p) {
          p.classList.remove(panelClass);
        });
        /* activate clicked tab */
        tab.classList.add(tabSelector.split('.').pop() + '--active');
        tab.setAttribute('aria-selected', 'true');
        /* show target panel */
        var targetId = tab.getAttribute('aria-controls');
        if (targetId) {
          var panel = document.getElementById(targetId);
          if (panel) panel.classList.add(panelClass);
        }
      });
    });
  }

  /* Segment tabs */
  (function () {
    var tabs = document.querySelectorAll('.boh__seg-tab');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('boh__seg-tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        document.querySelectorAll('.boh__seg-panel').forEach(function (p) {
          p.classList.remove('boh__seg-panel--active');
        });
        tab.classList.add('boh__seg-tab--active');
        tab.setAttribute('aria-selected', 'true');
        var targetId = tab.getAttribute('aria-controls');
        if (targetId) {
          var panel = document.getElementById(targetId);
          if (panel) panel.classList.add('boh__seg-panel--active');
        }
      });
    });
  })();

  /* Product catalogue tabs */
  (function () {
    var tabs = document.querySelectorAll('.boh__prod-tab');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('boh__prod-tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        document.querySelectorAll('.boh__prod-panel').forEach(function (p) {
          p.classList.remove('boh__prod-panel--active');
        });
        tab.classList.add('boh__prod-tab--active');
        tab.setAttribute('aria-selected', 'true');
        var targetId = tab.getAttribute('aria-controls');
        if (targetId) {
          var panel = document.getElementById(targetId);
          if (panel) panel.classList.add('boh__prod-panel--active');
        }
      });
    });
  })();

})();
